
//GA统计代码
const GAstatisticsPc = (lbl_category, user_event, lbl_event) => {
    window.ga('send', 'event', lbl_category, user_event, lbl_event);
    window.ga('RoeweActPc.send', 'event', lbl_category, user_event, lbl_event);
}

const GAstatisticsMb = (lbl_category, user_event, lbl_event) => {
    window.ga('send', 'event', lbl_category, user_event, lbl_event);
    window.ga('RoeweActMobile.send', 'event', lbl_category, user_event, lbl_event);
}

//限购城市id列表
const uploadCityArr = [ 
    '10000000000174',//北京
    '10000000000335',//上海
    '10000000000190',//广州
    '10000000000141',//深圳
    '10000000000042',//天津
    '10000000000250',//杭州
    '10000000000289',//南京
    '10000000000290',//无锡
    '10000000000301',//泉州
    '10000000000122',//莆田
    '10000000000168',//福州
    '10000000000084',//厦门
    '10000000000152',//东莞
    '10000000000241',//中山
    '10000000000316',//惠州
    '10000000000045',//石家庄
    '10000000000302',//廊坊
    '10000000000133'//兰州
]

//pc端车型数组
const vehicleTypeListPc = [{
    value: 'ERX5',
    label: 'ERX5'
}, {
    value: 'Ei5 300KM',
    label: 'Ei5 300KM'
}, {
    value: 'eRX5',
    label: 'eRX5'
}, {
    value: 'e950',
    label: 'e950'
}, {
    value: 'RX8',
    label: 'RX8'
}, {
    value: 'RX5',
    label: 'RX5'
}, {
    value: 'RX3',
    label: 'RX3'
}, {
    value: 'i6',
    label: 'i6'
}, {
    value: 'i5',
    label: 'i5'
}, {
    value: '360',
    label: '360'
}]

//移动端端车型数组
const vehicleTypeListMb = [{
  value: 'ERX5',
  text: 'ERX5'
}, {
  value: 'Ei5 300KM',
  text: 'Ei5 300KM'
}, {
  value: 'eRX5',
  text: 'eRX5'
}, {
  value: 'e950',
  text: 'e950'
}, {
  value: 'RX8',
  text: 'RX8'
}, {
  value: 'RX5',
  text: 'RX5'
}, {
  value: 'RX3',
  text: 'RX3'
}, {
  value: 'i6',
  text: 'i6'
}, {
  value: 'i5',
  text: 'i5'
}, {
  value: '360',
  text: '360'
}]


const msgUploadObj = {
    idcard: '身份证',
    license: '行驶证',
    invoice: '购车发票',
    place: '属地证明',
    oldlicense: '行驶证',
}

// base64转成bolb对象 
const dataURItoBlob = (base64Data) => { 
      let byteString; 
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
          byteString = atob(base64Data.split(",")[1]); 
      }else{
          byteString = unescape(base64Data.split(",")[1]);
      }
      let mimeString = base64Data .split(",")[0] .split(":")[1] .split(";")[0]; 
      let ia = new Uint8Array(byteString.length); 
      for (var i = 0; i < byteString.length; i++) { 
          ia[i] = byteString.charCodeAt(i); 
      } 
      return new Blob([ia], { type: mimeString }); 
  }

//异步加载js
const loadScript = (src, cb) => {
    const head = document.head || document.getElementsByTagName('head')[0]
    const script = document.createElement('script')
    cb = cb || function () {}
    script.type = 'text/javascript'
    script.src = src
    if (!('onload' in script)) {
      script.onreadystatechange = function () {
        if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
        this.onreadystatechange = null
        cb(script)
      }
    }
    script.onload = function () {
      this.onload = null
      cb(script)
    }
    head.appendChild(script)
}

//加载网易易盾
const addNetEaseDun = () => {
  //时间序列化
  const getTimestamp  = (msec) => {
      msec = !msec && msec !== 0 ? msec : 1
      return parseInt((new Date()).valueOf() / msec, 10)
  }
  return function(cb){
    return loadScript(`https://cstaticdun.126.net/load.min.js?t=${getTimestamp(1 * 60 * 1000)}`,cb)
  }
}
const initNetEaseDun = addNetEaseDun()

export {
    GAstatisticsPc,
    GAstatisticsMb,
    uploadCityArr,
    vehicleTypeListPc,
    vehicleTypeListMb,
    msgUploadObj,
    dataURItoBlob,
    initNetEaseDun
}
